export const markup = (html) => ({__html: html});
